import { Feed as FeedComponent, } from '@tribeplatform/react-components/Feed';
export const FeedBlock = FeedComponent;
//# sourceMappingURL=Block.js.map